<template>
    <v-text-field
            ref="input"
            readonly
            v-on="$listeners"
            :value="value"
            type="number"
            append-icon="add"
            @click:append="increment"
            prepend-inner-icon="remove"
            @click:prepend-inner="decrement"
            class="text-xs-center mx-0"
            style="max-width:100px"
            solo
            :hide-details="true"
            :disabled="disabled"
    >
    </v-text-field>
</template>

<script>
    export default {
        name: "Spinner",
        props: {
            value: {type: [String, Number], default: 0},
            rules: Array,
            selectedTicketsCount: Number,
            eventRemaining: Number,
            ticketRemaining: Number,
            disabled: Boolean
        },
        computed: {
            secureMaxValue() {
                if (this.ticketRemaining === null && this.eventRemaining === null) {
                    return 99;
                } else if (this.ticketRemaining === null) {
                    let eventMax = _.max([this.eventRemaining - this.selectedTicketsCount + this.value, 0]);
                    return _.min([eventMax, 99])
                } else if (this.eventRemaining === null) {
                    let ticketMax = _.max([this.ticketRemaining, 0]);
                    return _.min([ticketMax, 99])
                }
                let ticketMax = _.max([this.ticketRemaining, 0]);
                let eventMax = _.max([this.eventRemaining - this.selectedTicketsCount + this.value, 0]);
                return _.min([ticketMax, eventMax, 99])
            }
        },
        methods: {
            increment() {
                if (!this.disabled) {
                    this.$refs.input.focus();
                    this.$emit('input', Math.min(parseInt(this.value) + 1, this.secureMaxValue));
                }
            },
            decrement() {
                if (!this.disabled) {
                    this.$refs.input.focus();
                    this.$emit('input', Math.max(parseInt(this.value) - 1, 0));
                }
            }
        }
    }
</script>

<style scoped>
    >>> input {
        text-align: center;
    }
</style>
